export default "__VITE_PUBLIC_ASSET__13c674aa__"